import { useEffect, useState } from 'react';
import { fetchReportingMode } from './api';
import { ReportingMode } from './types';

export interface ReportingModeState {
  loaded: boolean;
  // null when the mode could not be read; callers keep the pre-mode
  // behaviour then.
  reportingMode: ReportingMode | null;
}

export const useReportingMode = (): ReportingModeState => {
  const [state, setState] = useState<ReportingModeState>({
    loaded: false,
    reportingMode: null,
  });

  useEffect(() => {
    let active = true;
    fetchReportingMode()
      .then((reportingMode) => {
        if (active) {
          setState({ loaded: true, reportingMode });
        }
      })
      .catch(() => {
        if (active) {
          setState({ loaded: true, reportingMode: null });
        }
      });
    return () => {
      active = false;
    };
  }, []);

  return state;
};
